// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"554":"badf1bff","807":"721ce99f","865":"86ea6cc1"}[chunkId] + ".chunk.css";
};